import { mapState, mapMutations } from 'vuex'
import maConfirmButton from '@/components/button-blue'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'
import maModal from '@/components/modal'
import warrantyModule from '@/store/modules/warranty'

// types
import { USER_MODULE_NAME, USER_SET_ID } from '@/modules/User/store/types'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_SINISTER_ID,
  FNOL_MODULE_NAME
} from '@/store/types'

export default {
  name: 'claimLanding',
  mixins: [userFlowMixin, flowMixin],

  data() {
    return {
      userTypeData: false,
      showGeneralValue: this.showGeneral,
      showCookiesValue: this.showCookies,
      showLegalValue: this.showLegal
    }
  },
  props: {
    showGeneral: {
      type: Boolean,
      required: false,
      default: true
    },
    showCookies: {
      type: Boolean,
      required: false,
      default: false
    },
    showLegal: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId'
    }),
    ...mapState(USER_MODULE_NAME, {
      stateUserId: 'userId',
      stateUserType: 'userType'
    }),
    ...mapState(FNOL_MODULE_NAME, {
      stateIdFlux: 'idFlux'
    }),
    getSinisterId() {
      return String(this.stateWarrantySinisterId) || sessionStorage.getItem('sinId') || ''
    }
  },
  components: {
    maConfirmButton,
    maModal
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateSinisterId: WARRANTY_UPDATE_SINISTER_ID
    }),
    ...mapMutations(USER_MODULE_NAME, {
      mutUserUpdateId: USER_SET_ID
    }),

    handleClickStartBtn: async function() {
      this.trackFlowStartHome()
      this.goToNextState()
    },
    trackFlowStart() {
      const startTrackMessage = `Selfcare - Acept terms & conditions`
      this.trackUserFlowTimeStamp(startTrackMessage, this.getSinisterId)
    },

    closeModalCookiesAndLegal() {
      localStorage.setItem('t&cAccept', true)
      this.trackFlowStart()
      this.$refs.modalCookiesAndLegal.closeModal()
    },

    handleShowCookies() {
      this.showGeneralValue = false
      this.showLegalValue = false
      this.showCookiesValue = true
    },

    handleShowLegal() {
      this.showGeneralValue = false
      this.showLegalValue = true
      this.showCookiesValue = false
    },

    handleShowGeneral() {
      this.showGeneralValue = true
      this.showLegalValue = false
      this.showCookiesValue = false
    },
    trackFlowStartHome() {
      const startTrackMessage = `Selfcare - View screen welcome`
      this.trackUserFlowTimeStamp(startTrackMessage, this.getSinisterId)
    }
  },

  mounted() {
    this.mutWarrantyUpdateSinisterId(sessionStorage.getItem('sinId'))
    this.mutUserUpdateId(this.$route.params.user)
    //TODO: MA-224, DISABLE COOKIES MODAL. It is commented by the moment, in the future, when the cookies are finally managed by ONETRUST, remove definitely.
    // if (localStorage.getItem('t&cAccept') && localStorage.getItem('t&cAccept') === 'true') {
    //   this.$refs.modalCookiesAndLegal.showModal = false
    // } else {
    //   this.$refs.modalCookiesAndLegal.showModal = true
    // }

    // Notify Vue App of the current active element in screen
    this.notifyAppOfChanges(this)
  },

  beforeCreate: function() {
    if (!(WARRANTY_MODULE_NAME in this.$store.state)) {
      this.$store.registerModule(WARRANTY_MODULE_NAME, warrantyModule)
    }
  }
}
